import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import homeList from '@/components/homeList'
import productinfo from '@/components/productinfo'
import modelList from '@/components/modelList'
import lessonList from '@/components/lessonList'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: { title: '首页' }
    },
    {
      path: '/home',
      name: 'homeList',
      component: homeList,
      meta: { title: '首页' }
    },
    {
      path: '/brickmodel',
      name: 'brickmodel',
      component: productinfo,
      meta: { title: '首页' }
    },
    {
      path: '/modelList',
      name: 'modelList',
      component: modelList,
      meta: { title: '首页' }
    },
    {
      path: '/lessonList',
      name: 'lessonList',
      component: lessonList,
      meta: { title: '首页' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js